import './style.scss'
import Layer from '../../Shared/Layer'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import Button from '../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'
import { PropTypes } from 'prop-types'
import { BUTTON_MIN_WIDTH } from '../Form/Button/constants'

const DeleteConfirmationOverlay = ({ onCancel, onConfirmation, question, information }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const performAction = useCallback(() => {
    setLoading(true)
    const res = onConfirmation()
    if (res instanceof Promise) {
      res.finally(() => {
        setLoading(false)
      })
    } else {
      setLoading(false)
    }
  }, [onConfirmation])
  return (
    <Layer
      disallowHiding={loading}
      type="center"
      size="small"
      id={'delete-confirmation'}
      show={true}
      onHideClick={onCancel}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="delete-confirmation-overlay"
      closeOnEsc={true}
    >
      <Container fluid>
        <Row style={{ alignItems: 'center' }}>
          <Col>
            <span className="delete-confirmation-overlay__delete_icon"></span>
          </Col>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <br/>
            <span className="delete-confirmation-overlay__header">
              {question}
            </span>
            {information && <>
              <br/>
              <br/>
              <span className="delete-confirmation-overlay__information">{information}</span>
            </>}
          </Col>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <br/>
            <Button variant="attention" disabled={loading} style={{ marginRight: 20 }} onClick={performAction}
                    minWidth={BUTTON_MIN_WIDTH}>{t('BUTTON_DELETE')}</Button>
            <Button variant="neutral" disabled={loading} onClick={onCancel}
                    minWidth={BUTTON_MIN_WIDTH}>{t('BUTTON_CANCEL')}</Button>
          </Col>
        </Row>
      </Container>
    </Layer>
  )
}

DeleteConfirmationOverlay.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  question: PropTypes.string.isRequired,
  information: PropTypes.string,
}

export default DeleteConfirmationOverlay
